export const OPERATOR_PROPS = {
  CREATE_OPERATOR: 'Create Operator',
  OPERATOR_DETAIL: 'OPERATOR',
  EDIT_OPERATOR: 'EDIT OPERATOR',
  OPERATOR_NAME: {
    PLACEHOLDER: 'Enter Operator Name',
    LABEL: 'Operator Name',
  },
  OPERATOR_ID: {
    PLACEHOLDER: 'Enter Source Id',
    LABEL: 'Source Id',
  },
  PROVIDER_ID: {
    PLACEHOLDER: 'Select Provider',
    LABEL: 'Provider',
  },
  SUb_APPLICATION_ID: {
    PLACEHOLDER: 'Select Application',
    LABEL: 'Sub Application Name',
  },
  BUTTON: {
    SAVE: 'SAVE',
    EDIT: 'UPDATE',
    ADD: 'Add Operator',
  },
  SEARCH_PLACE_HOLDER: {
    PLACE_HOLDER: 'Name',
  },
  MODAL: {
    CREATE_SUBTITLE: 'Fill in the details below to add a new operator',
    EDIT_SUBTITLE: 'Update the operator details below',
    CANCEL: 'Cancel',
  },
  DELETE_MODAL: {
    TITLE: 'Delete Operator',
    SUBTITLE: 'This action cannot be undone',
    BODY_PREFIX: 'Are you sure you want to delete operator',
    CANCEL: 'Cancel',
    CONFIRM: 'Delete',
    CONFIRM_WORD: 'delete',
    PLACEHOLDER: 'please type `delete`',
    INPUT_LABEL: 'Type the word above to confirm',
    HINT: 'This action will delete the operator permanently.',
  },
  ACTIVATE_MODAL: {
    TITLE: 'Reactivate Operator',
    SUBTITLE: 'This will restore the operator.',
    BODY_PREFIX: 'Are you sure you want to reactivate operator:',
    CONFIRM_WORD: 'activate',
    PLACEHOLDER: 'please type `activate`',
    INPUT_LABEL: 'Type the word above to confirm',
    HINT: 'This action will reactivate the operator.',
    CONFIRM_LABEL: 'Activate',
  },
  COLUMNS: {
    OPERATOR_ID: 'Operator ID',
    NAME: 'Name',
    SUB_APPLICATION: 'Sub Application',
    PROVIDER: 'Provider',
    OPERATOR_UUID: 'Operator UUID',
    CREATED_ON: 'Created On',
    UPDATED_ON: 'Updated On',
    ACTION: 'Action',
  },
};
